import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import SaveIcon from '@mui/icons-material/Save';
import { IconButton, Tooltip } from '@mui/material';

import { savePageAnnotations } from '../../actions/annotations';

type Props = ResolveThunks<typeof actionCreators>;

function SaveAnnotations(props: Props) {
  const { savePageAnnotations } = props;
  return (
    <Tooltip disableInteractive disableFocusListener id="reset-page-tooltip" title="Save Job">
      <div>
        <IconButton sx={{ borderRadius: 0, width: '100%' }} aria-label="Save Job" onClick={savePageAnnotations}>
          <SaveIcon />
        </IconButton>
      </div>
    </Tooltip>
  );
}

const actionCreators = {
  savePageAnnotations,
};

export default connect(null, actionCreators)(SaveAnnotations);
